import { useCallback } from 'react';
import { useCharlieConfirm } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../i18n/i18n';
import { useJourney } from './useJourney';

/**
 * Shared cancel confirmation handler.
 * Shows a destructive confirm dialog, then cancels the journey if confirmed.
 */
export function useCancelConfirm(): () => Promise<void> {
  const confirm = useCharlieConfirm();
  const { t } = useTranslation();
  const journey = useJourney();

  return useCallback(async () => {
    const confirmed = await confirm({
      title: t('abort.confirmTitle'),
      message: t('abort.confirmMessage'),
      confirmLabel: t('abort.confirmStop'),
      cancelLabel: t('abort.goBack'),
      variant: 'destructive',
    });
    if (confirmed) {
      await journey.cancel();
    }
  }, [confirm, t, journey]);
}
